<!-- Property of OSF GLOBAL SERVICES INC. , an OSF Digital company. OSF remains the sole owner of all right, title and interest in the software. Do not copy, sell, reverse engineer or otherwise attempt to derive or obtain information about the functioning, manufacture or operation therein. -->
<style lang="scss" scoped>
.answersWrapper {
    display: flex;
    justify-content: center;

    @media (max-width: 767px) {
        align-items: center;
        flex-direction: column;
    }
}

.answerItem {
    display: block;
    cursor: pointer;
    position: relative;
    border: 0;
    padding: 0;
}

.answerItem.disabled {
    cursor: auto;
}

.answerImage {
    display: flex;
    position: relative;
    flex-wrap: wrap;
    overflow: hidden;

    @media (max-width: 767px) {
        height: calc(45rem / var(--nbAnswers));
        width: 100vw;
    }
}

.answerImage img {
    display: block;
    width: 100%;
    height: 100%;
    transition: transform 0.5s;
    object-fit: cover;
}

.answerItem:hover .answerImage img {
    transform: scale(1.02);
}

.answerOverlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0.6;
    background-color: #000000;
    z-index: 1;
    transition: opacity 0.5s;
}

.answerItem:hover .answerOverlay {
    opacity: 0.2;
}

.answerContent {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    width: 100%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    padding: 0 1.5rem;
    z-index: 1;
}

.answerTitle {
    font-size: 1.75rem;

    @media (min-width: 1024px) {
        font-size: 3.5rem;
    }
}

.answerSelectedIcon {
    left: 1.25rem;
    transition: filter 0.1s;
}

@media (min-width: 1280px) {
    .answerSelectedIcon {
        position: absolute;
    }
}

.answer-button:focus-visible {
    outline: 3px solid #0070d2;
}

.answer-button:hover .answerSelectedIcon {
    filter: invert(1);
}
</style>

<template>
    <div class="template1wrapper">
        <div class="answersWrapper">
            <div v-for="answer in this.answers" :key="answer.id" class="answerItem"
                v-bind:class="[answer.selected ? 'selected' : '', answer.disabled ? 'disabled' : '']"
                :style="answerStyle" :title="answer.text" v-on:click="selectAnswer(answer.id)"
                v-bind:data-cbt="getDataCbtValue(answer)">
                <div class="answerImage" v-bind:data-cbt="getDataCbtValue(answer)">
                    <div class="answerOverlay" v-bind:data-cbt="getDataCbtValue(answer)" ></div>
                    <img :src="getAnswerImage(answer)" :alt="''" v-bind:data-cbt="getDataCbtValue(answer)" />
                </div>
                <div class="answerContent">
                    <div class="answerTitle"
                        :class="[answer.textColor === 'black' ? 'ti-text-color-black' : 'ti-text-color-white']"
                        v-bind:data-cbt="getDataCbtValue(answer)">
                        {{ answer.title }}
                    </div>
                    <button class="answer-button ti-btn mt-16 w-auto px-20 px-lg-50 position-relative"
                        :class="[answer.textColor === 'black' ? 'ti-btn-third bg-transparent' : 'ti-btn-ghost']"
                        v-on:click="selectAnswer(answer.id)"
                        :aria-label="answer.selected ? selectedButtonText : buttonText + ' ' + answer.title"
                        v-bind:data-cbt="getDataCbtValue(answer)">
                        <img class="answerSelectedIcon mr-8" v-if="answer.selected" :src="images.checkmark"
                            :alt="selectedButtonText" v-bind:data-cbt="getDataCbtValue(answer)" />
                        <span v-bind:data-cbt="getDataCbtValue(answer)">{{ answer.selected ? selectedButtonText : buttonText }}</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Q1Template",
    computed: {
        quizData: function () {
            return this.$store.state.quizData;
        },
        question: function () {
            return this.$store.state.questionData;
        },
        answers: function () {
            return this.$store.state.questionData.answers;
        },
        images: function () {
            return this.$store.state.quizData.images;
        },
        buttonText: function () {
            return this.$store.state.quizData.translations.templateq1buttontext;
        },
        selectedButtonText: function () {
            return this.$store.state.quizData.translations.templateq1selectedbuttontext;
        },
        answerStyle() {
            return {
                "--nbAnswers": this.answers.length,
            };
        },
    },
    methods: {
        selectAnswer: function (aid) {
            this.$store.commit("setAnswer", aid);
            let data = {
                quizid: this.quizData.quizid,
                qid: this.question.id,
                aid: [aid],
            };
            this.$store.dispatch("submitQuestion", data);
        },
        getAnswerImage: function (answer) {
            if (answer.image && answer.image !== " ") {
                return answer.image;
            }
            return this.images.noImage;
        },
        getDataCbtValue: function (answer) {
            let data = {
                "event" : "GiftFinderNavigation",
                "eventTypes": "click",
                "W-cat": "Gift Finder",
                "W-act": null,
                "W-lib": answer.englishTranslation
            }

            let questionStep;
            switch(this.question.id) {
                case "forYouOrGift" : {
                    questionStep = "Step 1";
                    break;
                }
                case "herHimUnisex" : {
                    questionStep = "Step 2";
                    break;
                }
                case "style"        : {
                    questionStep = "Step 3";
                    break;
                }
                case "dialColor"    : {
                    questionStep = "Step 4";
                    break;
                }
                case "strapMaterial": {
                    questionStep = "Step 5";
                    break;
                }
                case "price"        : {
                    questionStep = "Step 6";
                    break;
                }
                default             : {
                    questionStep = "Gift Finder";
                    break;
                }
            }

            data['W-act'] = questionStep;
            return JSON.stringify(data);
        }
    },
};
</script>
